import { render, staticRenderFns } from "./detailHistoricNews.vue?vue&type=template&id=112f7d5c&scoped=true&"
import script from "./detailHistoricNews.vue?vue&type=script&lang=js&"
export * from "./detailHistoricNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f7d5c",
  null
  
)

export default component.exports